import { render, staticRenderFns } from "./ArticleLink.vue?vue&type=template&id=1e380486&scoped=true"
import script from "./ArticleLink.vue?vue&type=script&lang=js"
export * from "./ArticleLink.vue?vue&type=script&lang=js"
import style0 from "./ArticleLink.vue?vue&type=style&index=0&id=1e380486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e380486",
  null
  
)

export default component.exports